export default {
  "content": "<g clip-path=\"url(#clip0_803_1975)\"><path d=\"M12.966.912H3a1.034 1.034 0 00-1.038 1.034v13.932A1.034 1.034 0 003 16.912h9.97A1.034 1.034 0 0014 15.878V1.946A1.034 1.034 0 0012.966.912zM8 15.912a1 1 0 110-2 1 1 0 010 2zm4-3.368a.368.368 0 01-.368.368H4.368A.368.368 0 014 12.544V3.28a.368.368 0 01.368-.368h7.264A.368.368 0 0112 3.28v9.264z\" fill=\"#5C6270\"/></g><defs><clipPath id=\"clip0_803_1975\"><path fill=\"#fff\" transform=\"translate(0 .912)\" d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "16",
    "height": "17",
    "viewBox": "0 0 16 17",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};